var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buttons flex align-center gap-4"},[(_vm.chatID)?_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.openChat}},[_vm._v("開啟 LINE 對話")]):_vm._e(),_c('el-button',{attrs:{"size":"mini","plain":""},on:{"click":_vm.showEditChatID}},[_vm._v("編輯 ChatID")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }